import AppStore from "./AppStore";
import { configure } from 'mobx';

configure({ enforceActions: "observed" }) // don't allow state modifications outside actions

export default {
	appStore: new AppStore()
}